import React, { useEffect, useState } from "react";
import RollerSwitcher from "../../../../components/common/RollerSwitcher/RollerSwitcher";

const CategoryTree = ({
  categories,
  selectedCategoryId,
  selectedShopId,
  onToggleCategory,
  onSelectCategory,
}) => {
  const [expandedMap, setExpandedMap] = useState({});

  useEffect(() => {
    setExpandedMap({});
  }, [selectedShopId]);

  const toggleExpand = (id) => {
    setExpandedMap((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleRowClick = (category, hasChildren, isExpanded) => {
    if (hasChildren) {
      if (selectedCategoryId !== category.id) {
        onSelectCategory && onSelectCategory(category);
        return;
      }
      toggleExpand(category.id);
      return;
    }
    onSelectCategory && onSelectCategory(category);
  };

  const renderTree = (list, level = 0) => {
    if (!Array.isArray(list) || !list.length) return null;
    return list.map((category) => {
      const hasChildren =
        Array.isArray(category.children) && category.children.length > 0;
      const isExpanded = !!expandedMap[category.id];
      return (
        <React.Fragment key={category.id}>
          <div
            className="JoinPosterAssortmentTree__row"
            style={{ paddingLeft: `${level * 16}px` }}
            onClick={() => handleRowClick(category, hasChildren, isExpanded)}
          >
            <div
              className={`JoinPosterAssortmentTree__name${
                selectedCategoryId === category.id ? " selected" : ""
              }`}
            >
              <span
                className={`JoinPosterAssortmentTree__triangle${
                  hasChildren ? "" : " placeholder"
                }${hasChildren && isExpanded ? " expanded" : ""}`}
              />
              <span className="JoinPosterAssortmentTree__title">
                {category.name}
              </span>
            </div>
            <div className="JoinPosterAssortmentTree__switch">
              <RollerSwitcher
                isActive={category.isAppVisible}
                bgColor="#9978e2"
                onClickAction={(event) => {
                  event.stopPropagation();
                  onToggleCategory &&
                    onToggleCategory(category, !category.isAppVisible);
                }}
              />
            </div>
          </div>
          {hasChildren && isExpanded && renderTree(category.children, level + 1)}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="JoinPosterAssortmentTree JoinPosterAssortmentPanel">
      <div className="JoinPosterAssortmentPanel__header">
        <span>Категорії</span>
        <span>Відображати{"\n"}в застосунку</span>
      </div>
      <div className="JoinPosterAssortmentPanel__body">
        {renderTree(categories, 0)}
      </div>
    </div>
  );
};

export default CategoryTree;
